import { TextField } from '@client/new/components/basic';
import { LandingMediaDropbox } from './MediaDropBox';
import { FieldTitle } from './RedStarTitle';
import { faImage, faVideo } from '@fortawesome/pro-regular-svg-icons';
import { useFormContext, Controller } from 'react-hook-form';
import { FieldDesc } from './common';
import { BulletsInput } from './BulletsInput';
import { TwoColumns } from './layouts';

type Props = {
  imageUpload: (file: File) => Promise<string>;
  videoUpload: (file: File) => Promise<string>;
  index: number;
};
export function IntroductionForm({ imageUpload, videoUpload, index }: Props) {
  const { register, control } = useFormContext();
  const r = (s) => register(`sections.${index}.${s}`);

  const firstCol = (
    <>
      <div>
        <FieldTitle title={'Headline'} />
        <FieldDesc>
          The headline is used to communicate the creator’s value proposition in
          the hero section of the sales page.
        </FieldDesc>
        <TextField
          {...r(`title`)}
          className="mb-[5px] max-w-[680px] w-full"
          inputProps={{
            placeholder: 'Headline text',
            maxLength: 60,
          }}
        />
      </div>

      <div>
        <FieldTitle title={'Highlighted text'} />
        <FieldDesc>Some slogan</FieldDesc>
        <TextField
          {...r(`subtitle`)}
          className="mb-[5px] max-w-[680px] w-full"
          inputProps={{
            placeholder: 'Reach some goal',
            maxLength: 60,
          }}
        />
      </div>

      <div>
        <FieldTitle title={'Bullets'} />
        <FieldDesc>Bullet points that communicate value proposition</FieldDesc>
        <BulletsInput name={`sections.${index}.bullets`} />
      </div>
    </>
  );

  const coverImageInput = (
    <Controller
      name={`sections.${index}.coverImage`}
      control={control}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <LandingMediaDropbox
          upload={imageUpload}
          inputRef={ref}
          label="Cover image"
          validationText="The Intro image is used as the preview for the intro video. It will be cropped as square."
          value={value}
          onChange={onChange}
          type="image"
          icon={faImage as any}
          errorMsg={error?.message}
        >
          <ul className="text-black list-none text-center text-h12">
            <li>Square image/gif, max 5MB</li>
          </ul>
        </LandingMediaDropbox>
      )}
    />
  );

  const videoImageInput = (
    <Controller
      name={`sections.${index}.introVideo`}
      control={control}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <LandingMediaDropbox
          upload={videoUpload}
          inputRef={ref}
          label="Intro video"
          validationText="The intro video is used to provide a compelling introduction to the creator’s app and channel."
          value={value}
          onChange={onChange}
          type="video"
          icon={faVideo as any}
          errorMsg={error?.message}
          optional
        >
          <ul className="text-black list-none text-center text-h12">
            <li>Max 90 seconds</li>
            <li>Max 100MB</li>
          </ul>
        </LandingMediaDropbox>
      )}
    />
  );

  const secondCol = (
    <TwoColumns first={coverImageInput} second={videoImageInput} />
  );

  return <TwoColumns first={firstCol} second={secondCol} />;
}
